import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';
import { CurrencyFormat } from '../../waitingnotes.component';

export interface RecapItem {
  name: string;
  total_ttc: number;
}

export interface RecapPaymentDialogData {
  items: RecapItem[];
  totalAmount: number;
  tipAmount: number;
  alreadyPaidAmount: number;
  returnAmount: number;
  currencyFormat: CurrencyFormat;
}

@Component({
  selector: 'app-recap-payment-dialog',
  templateUrl: './recap-payment-dialog.component.html',
  styleUrls: ['./recap-payment-dialog.component.css']
})
export class RecapPaymentDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<RecapPaymentDialogComponent>,
    public cssService: CssService,
    @Inject(MAT_DIALOG_DATA) public data: RecapPaymentDialogData
  ) { }

  isClosing = false;
  selectedTips = 0;

  onConfirm(): void {
    if (this.data.returnAmount > (this.data.totalAmount - this.data.alreadyPaidAmount)) {
      this.selectedTips = (this.data.totalAmount - this.data.alreadyPaidAmount);
    } else {
    this.selectedTips = this.data.returnAmount;
    }
    this.isClosing = true;
  }

  onCancel() {
    this.selectedTips = 0;
    this.isClosing = true;
  }

  onAnimationEnd() {
    if (this.isClosing) {
      this.dialogRef.close(this.selectedTips);
    }
  }
}
